<template>
  <div>
    <v-row>
      <v-col class="col-12 col-md-8">
        <v-container fluid>
          <div class="text-h6 white--text d-md-none" style="margin-top: 10px;">Agora, selecione a promoção<br />que você deseja</div>
          <div class="text-h6 black--text d-none d-md-block" style="margin-top: 10px;">Agora, selecione a promoção<br />que você deseja</div>
          <div class="text-caption white--text d-md-none">{{ parques[carrinho.parque].nome }} > {{ mes }} {{carrinho.data.substr(0, 4) }} > {{ carrinho.data.split('-').reverse().join('/').substr(0,5) }}</div>
          <div class="text-caption black--text d-none d-md-block">{{ parques[carrinho.parque].nome }} > {{ mes }} {{carrinho.data.substr(0, 4) }} > {{ carrinho.data.split('-').reverse().join('/').substr(0,5) }}</div>
          <v-row fluid>
            <v-col class="col-12 col-md-6" :key="idx" v-for="(passaporte, idx) in lista">
              <detalhe-passaporte :data="passaporte"></detalhe-passaporte>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-container fluid>
        Adicione os passaportes ao carrinho<br />
        Logo após e clique em comprar
        </v-container>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import DetalhePassaporte from '@/components/DetalhePassaporte.vue'

import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Passaporte',
  components: { DetalhePassaporte },
  computed: {
    ...mapState(['parques', 'carrinho']),
    ...mapGetters(['listaPassaportes', 'totalCarrinho']),
    lista: function () {
      const lista = this.listaPassaportes(this.carrinho.parque * 1)
      const disponiveis = []
      for (let i = 0; i < lista.length; i++) {
        if (lista[i].inicio === '0000-00-00') {
          disponiveis.push(lista[i])
        } else {
          const dt1 = this.carrinho.data.split('-')
          const dtIni = lista[i].inicio.split('-')
          const dtFim = lista[i].validade.split('-')
          const d1 = new Date(dt1[0], parseInt(dt1[1]) - 1, dt1[2])
          const d2 = new Date(dtIni[0], parseInt(dtIni[1]) - 1, dtIni[2])
          const d3 = new Date(dtFim[0], parseInt(dtFim[1]) - 1, dtFim[2])
          if (d1 >= d2 && d1 <= d3) {
            disponiveis.push(lista[i])
          } else {
          }
        }
      }
      return disponiveis
    },
    mes: function () {
      switch (this.carrinho.data.substr(5, 2)) {
        case '01': return 'Janeiro'
        case '02': return 'Fevereiro'
        case '03': return 'Março'
        case '04': return 'Abril'
        case '05': return 'Maio'
        case '06': return 'Junho'
        case '07': return 'Julho'
        case '08': return 'Agosto'
        case '09': return 'Setembro'
        case '10': return 'Outubro'
        case '11': return 'Novembro'
        case '12': return 'Dezembro'
      }
      return ''
    }
  }
}
</script>
